/** @jsxRuntime classic */
/** @jsx jsx */

import { css, jsx } from '@emotion/react';
import { Breadcrumbs as BreadcrumbsZDS, Link } from '@zapier/design-system';
import { labelStyles } from '@zapier/style-encapsulation';
import {
  useAvroTracking,
  EventAction,
  InteractionName,
} from '../../observability';

type Props = {
  currentPage?: string;
  links?: { text: string; href: string }[];
  size?: 'small' | 'large';
};

const Styles = labelStyles('Breadcrumbs', {
  root: css({
    margin: '0 auto',
    maxWidth: '1170px',
    padding: '20px',
  }),
});

export function Breadcrumbs(props: Props) {
  const { emitUserInteractionEvent } = useAvroTracking();

  return (
    <div css={Styles.root}>
      <BreadcrumbsZDS size={props.size}>
        {props.links?.map((link) => (
          <Link
            href={link.href}
            key={link.href}
            onClick={() => {
              emitUserInteractionEvent({
                event_action: EventAction.click,
                interaction_name: InteractionName.navigation,
                interaction_raw_text: link.text,
                option_selected: 'breadcrumb_link',
                destination_href: link.href,
              });
            }}
          >
            {link.text}
          </Link>
        ))}
        {props.currentPage && <span>{props.currentPage}</span>}
      </BreadcrumbsZDS>
    </div>
  );
}
